import { render, staticRenderFns } from "./ManagersList.vue?vue&type=template&id=1ddfd9f3&scoped=true&"
import script from "./ManagersList.vue?vue&type=script&lang=js&"
export * from "./ManagersList.vue?vue&type=script&lang=js&"
import style0 from "./ManagersList.vue?vue&type=style&index=0&id=1ddfd9f3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddfd9f3",
  null
  
)

export default component.exports